import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';
import { CheckRegularGlyph } from '@acast-tech/decibel-glyphs';
import { Icon } from '@acast-tech/decibel';
import { highlightMatch, type Option } from '.';

type ComboboxListItemProps = {
  option: Option;
  onClick: (option: Option) => void;
  index: number;
  state: {
    selectedOptions: Option[];
    highlightedIndex: number;
    inputValue: string;
  };
};

const ComboboxListItem = forwardRef<HTMLLIElement, ComboboxListItemProps>(
  ({ option, onClick, index, state }, ref) => {
    const { selectedOptions, highlightedIndex, inputValue } = state;
    return (
      <li
        ref={ref}
        role="option"
        id={`combobox-option-${index}`}
        aria-label={option.name}
        aria-selected={selectedOptions.some((o) => o.id === option.id)}
        onClick={() => onClick(option)}
        className={twMerge(
          'p-3 cursor-pointer hover:bg-primary/10 flex items-center gap-2',
          selectedOptions.some((o) => o.id === option.id) && 'bg-primary/10',
          highlightedIndex === index && 'bg-primary/10'
        )}
      >
        {selectedOptions.some((o) => o.id === option.id) && (
          <Icon glyph={CheckRegularGlyph} size="xsmall" primaryColor="#4040a8" />
        )}
        {highlightMatch(option.name, inputValue)}
      </li>
    );
  }
);

export default ComboboxListItem;
